import { render, staticRenderFns } from "./addChildren.vue?vue&type=template&id=b670a384"
import script from "./addChildren.vue?vue&type=script&lang=js"
export * from "./addChildren.vue?vue&type=script&lang=js"
import style0 from "./addChildren.vue?vue&type=style&index=0&id=b670a384&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports